import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@24.0.12_@upstash+redis@1.35.0_@vue+compil_b3ee511c7aa76bc863274f28eb4bfaec/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}